// Pizza no Relatório de Estoque (25/10/2026): a ficha dela é por tamanho
// (`products.pizza_recipes` = {size_id: [linhas]}, features/pizza-ficha), não a
// `recipe` comum — por isso toda pizza aparecia "sem ficha técnica".
//
// A linha da pizza usa o tamanho de referência: o do preço de venda do cadastro
// (o mesmo que a tela já mostrava como "Venda"); sem ele, o tamanho mais caro com
// ficha. O custo do que foi vendido soma cada tamanho pelo custo dele.
import { custoFicha } from "../../pizza-ficha/lib/calculo";

const lista = (v) => {
  if (Array.isArray(v)) return v;
  try { const p = JSON.parse(v || "[]"); return Array.isArray(p) ? p : []; } catch { return []; }
};
const objeto = (v) => {
  if (v && typeof v === "object") return v;
  try { const p = JSON.parse(v || "{}"); return p && typeof p === "object" ? p : {}; } catch { return {}; }
};
const etapa = (steps, kind, nome) =>
  steps.find((s) => s?.kind === kind) || steps.find((s) => String(s?.name || "").trim().toLowerCase() === nome);

/** Tamanhos da pizza com preço e custo: [{ id, nome, preco, cmv }]. Vazio se não for pizza com ficha. */
export function tamanhosDaPizza(produto, produtosPorId, ingredientesPorId) {
  if ((produto.product_type || "") !== "pizza") return [];
  const fichas = objeto(produto.pizza_recipes);
  if (!Object.keys(fichas).length) return [];
  // Sabor "sincronizado" não tem etapas próprias: tamanhos e preços vêm da pizza-mãe.
  let steps = lista(produto.order_steps);
  if (!etapa(steps, "pizza_size", "tamanho") && produto.sync_order_steps_from_id) {
    steps = lista(produtosPorId[produto.sync_order_steps_from_id]?.order_steps);
  }
  const tamanhos = etapa(steps, "pizza_size", "tamanho")?.items || [];
  const sabor = (etapa(steps, "pizza_flavor", "sabores")?.items || []).find((i) => i?.product_id === produto.id);
  return tamanhos.filter((t) => t?.id).map((t) => ({
    id: t.id,
    nome: t.name || "",
    preco: Number(sabor?.prices_by_size?.[t.id]) || Number(t.base_price) || 0,
    cmv: custoFicha(fichas[t.id], ingredientesPorId),
  }));
}

/** Tamanho que representa a pizza na tabela, ou null se nenhum tamanho tem ficha e preço. */
export function tamanhoDeReferencia(tamanhos, precoCadastro) {
  const validos = tamanhos.filter((t) => t.cmv > 0 && t.preco > 0);
  if (!validos.length) return null;
  return validos.find((t) => Math.abs(t.preco - precoCadastro) < 0.005)
    || validos.reduce((a, b) => (b.preco > a.preco ? b : a));
}

/** Custo do que foi vendido: cada tamanho pelo custo dele. Tamanho sem ficha, e
 *  pizza vendida sem o tamanho gravado (pedido antigo de Mesas), usam o de referência. */
export function custoVendidoDaPizza(tamanhos, referencia, porTamanho, vendidas) {
  if (!referencia) return null;
  let qtdComTamanho = 0;
  let custo = 0;
  for (const [id, qtd] of Object.entries(porTamanho || {})) {
    const q = Number(qtd) || 0;
    const t = tamanhos.find((x) => x.id === id);
    qtdComTamanho += q;
    custo += q * (t?.cmv > 0 ? t.cmv : referencia.cmv);
  }
  return custo + Math.max(0, (Number(vendidas) || 0) - qtdComTamanho) * referencia.cmv;
}
